var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      !_vm.isLoading
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("h4", [
                _vm._v(
                  _vm._s(
                    _vm.$t("speciesCount", {
                      count: _vm.filteredSpeciesList.length
                    })
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row", staticStyle: { "max-width": "340px" } }, [
        _c("div", { staticClass: "col-2" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "text-overline" }, [
                _vm._v(_vm._s(_vm.$t("filter")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("q-btn", {
                  class: {
                    "bg-primary": _vm.displayGalleryFilters,
                    "text-white": _vm.displayGalleryFilters
                  },
                  attrs: {
                    icon: "filter_list",
                    color: "primary",
                    outline: "",
                    dense: ""
                  },
                  on: {
                    click: function($event) {
                      _vm.displayGalleryFilters = !_vm.displayGalleryFilters
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-7" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "text-overline" }, [
                _vm._v(_vm._s(_vm.$t("sorting")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _vm.galleryView === _vm.GALLERY_VIEW.TEASER
                  ? _c("q-btn", {
                      attrs: {
                        color: "primary",
                        label: _vm.$t("label.color"),
                        icon: _vm.sortingIcon,
                        "no-caps": ""
                      },
                      on: { click: _vm.changeGallerySortingDirection }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.galleryView === _vm.GALLERY_VIEW.LIST
                  ? _c(
                      "q-btn-dropdown",
                      {
                        attrs: {
                          split: "",
                          color: "primary",
                          label: _vm.$t(
                            "button.listtype." + _vm.gallerySorting
                          ),
                          icon: _vm.sortingIcon,
                          "no-caps": ""
                        },
                        on: { click: _vm.changeGallerySortingDirection }
                      },
                      [
                        _c(
                          "q-list",
                          [
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-popup",
                                    rawName: "v-close-popup"
                                  }
                                ],
                                attrs: { clickable: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.setGallerySorting(
                                      _vm.GALLERY_SORTING.NAME
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-item-section",
                                  [
                                    _c("q-item-label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("button.listtype.name"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-popup",
                                    rawName: "v-close-popup"
                                  }
                                ],
                                attrs: { clickable: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.setGallerySorting(
                                      _vm.GALLERY_SORTING.TRADENAME
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-item-section",
                                  [
                                    _c("q-item-label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("button.listtype.tradename")
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-popup",
                                    rawName: "v-close-popup"
                                  }
                                ],
                                attrs: { clickable: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.setGallerySorting(
                                      _vm.GALLERY_SORTING.BOTANICALNAME
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-item-section",
                                  [
                                    _c("q-item-label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "button.listtype.botanicalname"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "text-overline" }, [
                _vm._v(_vm._s(_vm.$t("viewType")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "q-tabs",
                  {
                    attrs: {
                      value: _vm.galleryView,
                      "active-color": "white",
                      "active-bg-color": "primary",
                      align: "left",
                      breakpoint: 0,
                      outline: "",
                      shrink: "",
                      dense: ""
                    }
                  },
                  [
                    _c("q-tab", {
                      staticClass: "gallery-tab gallery-tab-left",
                      attrs: {
                        name: _vm.GALLERY_VIEW.TEASER,
                        icon: "view_module",
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setGalleryView(_vm.GALLERY_VIEW.TEASER)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("q-tab", {
                      staticClass: "gallery-tab gallery-tab-right",
                      attrs: {
                        name: _vm.GALLERY_VIEW.LIST,
                        icon: "view_column",
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setGalleryView(_vm.GALLERY_VIEW.LIST)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "q-slide-transition",
        [
          _vm.displayGalleryFilters
            ? _c("gallery-filters", { staticClass: "q-mt-md" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("q-spinner-cube", {
            staticClass: "absolute-center",
            attrs: { color: "primary", size: "3em" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "q-tab-panels",
        {
          staticClass: "q-mt-lg q-pa-none bg-transparent",
          attrs: { value: _vm.galleryView, animated: "", "keep-alive": "" }
        },
        [
          _c(
            "q-tab-panel",
            {
              staticClass: "q-pa-none",
              attrs: { name: _vm.GALLERY_VIEW.TEASER }
            },
            [_c("GalleryTeaserList")],
            1
          ),
          _vm._v(" "),
          _c(
            "q-tab-panel",
            {
              staticClass: "q-pa-none",
              attrs: { name: _vm.GALLERY_VIEW.LIST }
            },
            [_c("GalleryList")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }